var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14V18L10.4387 19.6838C10.2229 20.3313 10.7049 21 11.3874 21H14C14 22.1046 14.8954 23 16 23C17.1046 23 18 22.1046 18 21H20.6126C21.2951 21 21.7771 20.3313 21.5613 19.6838L21 18V14C21 11 18.9877 9 15.9938 9C13 9 11 11 11 14ZM19.9189 20C20.2601 20 20.5011 19.6657 20.3932 19.3419L20 18.1623V14C20 12.729 19.5782 11.746 18.9134 11.083C18.2484 10.4197 17.2632 10 15.9938 10C14.7247 10 13.7433 10.4195 13.0816 11.0818C12.4199 11.7441 12 12.7272 12 14V18.1623L11.6068 19.3419C11.4989 19.6657 11.7399 20 12.0811 20H19.9189Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.10e457bb04a3301679feadc36b79d71b.svg";
export { ForwardRef as ReactComponent };